// The API_URL will only be read at compile time, that means that the value in
// ApiUrl will not be updated if only the environment variable is changed.
// An asset compilation is required for ApiUrl to obtain the latest value from
// the API_URL environment variable. The API_URL is required to configure the
// API URL differently in each environment (local dev, staging, production).
export const ApiUrl = process.env.API_URL;
